import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomHeader from "../../Components/CustomHeader";
import { setLogOff as setLogOffActionCreator } from "../../Reducers/Login/Actions";
import { showOutfit } from "../../Reducers/Outfit/Actions";
import { fetchCategories } from "../../Reducers/Products/Actions";
import { DefaultRootState } from "../../Types/Types";
import { first, get, values } from "lodash";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";

const CustomHeaderContainer = (props) => {
  const dispatch = useDispatch();

  const item = useSelector(
    (state: DefaultRootState) => state.configurator?.configuration?.item
  );
  const { isLoggedIn, isValidLogin, selectedSkiSchool } = useSelector(
    (state: DefaultRootState) => state.login
  );
  // @ts-ignore
  const categories = useSelector((state) => state.products.categories);

  const setLogOff = () => dispatch(setLogOffActionCreator());

  const selectedDesignViewIdentifier = useSelector((state) =>
    get(state, "designView.designViews[0].identifier", null)
  );
  const getScreenshotImage = async () => {
    const screenshot = await Services.visualization.getScreenshots();
    return selectedDesignViewIdentifier
      ? first(values(screenshot))[selectedDesignViewIdentifier]
      : null;
  };

  return (
    <CustomHeader
      {...props}
      item={item}
      isLoggedIn={isLoggedIn}
      isValidLogin={isValidLogin}
      selectedSkiSchool={selectedSkiSchool}
      categories={categories}
      setLogOff={setLogOff}
      showOutfit={(isVisible, screenshot) => {
        dispatch(showOutfit(isVisible, screenshot));
      }}
      fetchCategories={() => {
        dispatch(fetchCategories());
      }}
      getScreenshotImage={getScreenshotImage}
    />
  );
};

export default CustomHeaderContainer;
